function is(val, type) {
  return Object.prototype.toString.call(val) === `[object ${type}]`
}

function isString(val) {
  return is(val, 'String')
}

export const drawLogo = ({ canvas, logo }) => {
  if (!logo) {
    return new Promise((resolve) => {
      resolve(canvas.toDataURL())
    })
  }

  // 获取原始的canvas宽高
  const originalWidth = canvas.width
  const originalHeight = canvas.height

  // 获取logo相关属性
  const canvasWidth = originalWidth
  const {
    logoSize = 0.23,
    bgColor = '#ffffff',
    borderSize = 0,
    crossOrigin = 'Anonymous',
    borderRadius = 8,
    logoRadius = 0,
  } = logo

  const logoSrc = isString(logo) ? logo : logo.src
  const logoWidth = canvasWidth * logoSize
  const logoXY = (canvasWidth * (1 - logoSize)) / 2
  const logoBgWidth = canvasWidth * (logoSize + borderSize)
  const logoBgXY = (canvasWidth * (1 - logoSize - borderSize)) / 2

  const ctx = canvas.getContext('2d')
  if (!ctx) return

  // 创建logo图像
  const image = new Image()
  image.crossOrigin = crossOrigin || 'Anonymous'
  image.src = logoSrc

  return new Promise((resolve) => {
    image.onload = () => {
      // 清除logo区域，确保不重叠
      ctx.clearRect(logoXY, logoXY, logoWidth, logoWidth)
      // 获取设备像素比率
      const dpr = window.devicePixelRatio || 1
      // 保存原始内容
      const tempCanvas = document.createElement('canvas')
      tempCanvas.width = originalWidth * dpr
      tempCanvas.height = originalHeight * dpr
      const tempCtx = tempCanvas.getContext('2d')
      if (!tempCtx) return
      
      // 在缩放后的临时画布上绘制原始内容
      tempCtx.drawImage(canvas, 0, 0, originalWidth * dpr, originalHeight * dpr)
      
      // 清除画布内容
      ctx.clearRect(0, 0, originalWidth, originalHeight)

      // 调整canvas尺寸
      canvas.width = originalWidth * dpr
      canvas.height = originalHeight * dpr
      ctx.scale(dpr, dpr)

      // 重新绘制原始内容
      ctx.drawImage(tempCanvas, 0, 0, originalWidth, originalHeight)

      // 绘制logo底色
      canvasRoundRect(ctx)(logoBgXY, logoBgXY, logoBgWidth, logoBgWidth, borderRadius)
      ctx.fillStyle = bgColor
      ctx.fill()

      // 选择绘制方式
      const drawLogo = logoRadius ? drawLogoWithCanvas : drawLogoWithImage
      drawLogo(ctx, image, logoXY, logoWidth, logoRadius)

      resolve(canvas.toDataURL())
    }
  })
}

// 绘制logo的方法
function drawLogoWithImage(ctx, image, x, width) {
  ctx.drawImage(image, x, x, width, width)
}

function drawLogoWithCanvas(ctx, image, x, width, radius) {
  const canvasImage = document.createElement('canvas')
  canvasImage.width = width
  canvasImage.height = width
  const imageCanvas = canvasImage.getContext('2d')
  if (!imageCanvas) return
  imageCanvas.drawImage(image, 0, 0, width, width)

  canvasRoundRect(ctx)(x, x, width, width, radius)
  const fillStyle = ctx.createPattern(canvasImage, 'no-repeat')
  if (fillStyle) {
    ctx.fillStyle = fillStyle
    ctx.fill()
  }
}

// 绘制圆角矩形的辅助函数
function canvasRoundRect(ctx) {
  return (x, y, w, h, r) => {
    const minSize = Math.min(w, h)
    if (r > minSize / 2) {
      r = minSize / 2
    }
    ctx.beginPath()
    ctx.moveTo(x + r, y)
    ctx.arcTo(x + w, y, x + w, y + h, r)
    ctx.arcTo(x + w, y + h, x, y + h, r)
    ctx.arcTo(x, y + h, x, y, r)
    ctx.arcTo(x, y, x + w, y, r)
    ctx.closePath()
    return ctx
  }
}
